module.exports = __webpack_public_path__ + "img/04.34db6287.jpg";